import { Common } from './common';
import { PatientAdvisory } from './models/patientAdvisory';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAllByEncounterId(encounterId: string): Promise<PatientAdvisory[]> {
    const url = this.common.constructPath(`/patient-advisories`, {
      encounterId,
    });

    return this.common.getJSON(url);
  }
}
